import 'components/Link/Link.scss';

export const Link = ({ children, text, external, ...props }) => (
  <a className='link' {...(external && { target: '_blank', rel: 'noreferrer noopener' })} {...props}>
    {children || text}
  </a>
);
